import { apiGet, apiPostForm, apiUrl } from "../../shared/api";
import { downloadFile } from "../../shared/download";

/** Un mese gia' prodotto. Gli importi sono STRINGHE: arrivano da Decimal e
 *  passare da un float perderebbe esattezza su un documento contabile. */
export type RiepilogoMese = {
  chiave: string;
  anno: number;
  mese: number;
  etichetta: string;
  nome_file: string;
  righe: number;
  gia_fatturate: number;
  positive: number;
  rimborsi: number;
  tipo_ignoto: number;
  estere: number;
  iva_marketplace: number;
  totale_positivi: string;
  totale_rimborsi: string;
  prima_data: string;
  ultima_data: string;
  generato_il: string;
  sostituisce: string | null;
  sostituisce_righe: number | null;
};

export type EsitoCaricamento = {
  mesi: RiepilogoMese[];
  righe_lette: number;
  righe_senza_data: number;
};

const ROTTA = "/api/invoicing/corrispettivi-amazon";

export function caricaTaxReport(file: File): Promise<EsitoCaricamento> {
  const body = new FormData();
  body.append("file", file);
  return apiPostForm(ROTTA, body);
}

export function fetchStorico(signal?: AbortSignal): Promise<RiepilogoMese[]> {
  return apiGet(ROTTA, signal ? { signal } : undefined);
}

/** ``apiUrl`` e non il default ``apiAssetUrl``: in DEV il download deve
 *  passare dal proxy Vite (stessa origin = cookie di sessione). */
export function scaricaMese(mese: RiepilogoMese): Promise<void> {
  return scaricaMesePerChiave(mese.chiave, mese.nome_file);
}

export function scaricaMesePerChiave(chiave: string, nomeFallback: string): Promise<void> {
  const path = `${ROTTA}/${chiave}`;
  return downloadFile(path, nomeFallback, apiUrl(path));
}
